export default __webpack_public_path__ + "static/azure-88317a49df91a9a2844232879a91dd93.png";